/**
 * t362u: a done or closed task / issue in the feed: a thin full-width strip across the top of its card, green for
 * done ("Resolved 20 Oct", "Completed 20 Oct") and grey for closed without a fix ("Closed 20 Oct", "Cancelled …").
 * The rest of the card is quieter (CLOSED_* below). Colours are FEED_CLOSURE_COLOURS, the same as the app's.
 */
import clsx from 'clsx';
import { Archive, Check } from 'lucide-react';
import { feedClosureText, type FeedClosure } from '@tradeoutlet/shared';

const TONE = {
  done: 'bg-[#047857] text-[#ffffff] dark:bg-[#065f46] dark:text-[#ecfdf5]',
  closed: 'bg-[#e2e8f0] text-[#334155] dark:bg-[#334155] dark:text-[#e2e8f0]',
} as const;

/** The card's title, faded but readable (AA): slate-600 / dark slate-300. */
export const CLOSED_TITLE = 'text-slate-600 dark:text-slate-300';
/** The description: slate-500 / dark slate-400. */
export const CLOSED_BODY = '!text-slate-500 dark:!text-slate-400';
/** Decorative bits (the type icon, the photo). */
export const CLOSED_FADE = 'opacity-60';

export function FeedClosureStrip({ closure, className }: { closure: FeedClosure; className?: string }) {
  const Icon = closure.tone === 'done' ? Check : Archive;
  return (
    <div className={clsx('flex h-6 items-center gap-1.5 px-4 text-xs font-semibold leading-4', TONE[closure.tone], className)}
      data-testid="feed-closure" data-tone={closure.tone}>
      <Icon className="h-3.5 w-3.5 shrink-0" strokeWidth={2.5} aria-hidden />
      <span className="truncate">{feedClosureText(closure)}</span>
    </div>
  );
}
